import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { checkMonthlyPlanEnding } from '../utils/notificationService';

/**
 * Componente que verifica periodicamente a expiração dos planos mensais
 * e cria notificações apropriadas
 */
const PlanExpirationChecker = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      return;
    }

    // Executar verificação imediatamente ao montar
    const result = checkMonthlyPlanEnding();
    result.catch(err => {
      // Erro ao executar verificação
    });

    // Executar verificação a cada 12 horas
    const interval = setInterval(() => {
      checkMonthlyPlanEnding();
    }, 12 * 60 * 60 * 1000); // 12 horas em milissegundos (12 horas * 60 minutos * 60 segundos * 1000 ms)

    // Limpar intervalo ao desmontar
    return () => {
      clearInterval(interval);
    };
  }, [user]);

  // Este componente não renderiza nada
  return null;
};

export default PlanExpirationChecker;

